import { useMemo } from 'react';
import { useLanguage } from '@contexts/LanguageContext';

/**
 * Hook to process and enhance filter options with auto-fetched data
 */
export const useProcessedFilterOptions = ({
    filterOptions = [],
    categories = [],
    locations = [],
    tags = [],
    resources = []
}) => {
    const { t } = useLanguage();

    return useMemo(() => {
        if (!filterOptions || filterOptions.length === 0) return [];

        return filterOptions.map(filter => {
            // If options are already provided, use them
            if (filter.options && filter.options.length > 0) {
                return filter;
            }

            // Auto-populate options based on fetched data
            let options = [];

            if (filter.key === 'category_ids' && categories && categories.length > 0) {
                options = categories.map(cat => ({ value: cat.id, label: cat.name }));
            } else if (filter.key === 'location_id' && locations && locations.length > 0) {
                options = locations.map(loc => ({ value: loc.id, label: loc.name }));
            } else if (filter.key === 'tag_ids' && tags && tags.length > 0) {
                options = tags.map(tag => ({ value: tag.id, label: tag.name }));
            } else if (filter.key === 'resource_id' && resources && resources.length > 0) {
                options = [
                    { value: '', label: t('reservation.allResources') },
                    ...resources.map(res => ({ value: res.id, label: res.name }))
                ];
            } else if (filter.endpoint) {
                // Handle custom endpoints
                switch (filter.endpoint) {
                    case 'categories':
                        if (categories && categories.length > 0) {
                            options = categories.map(cat => ({ value: cat.id, label: cat.name }));
                        }
                        break;
                    case 'locations':
                        if (locations && locations.length > 0) {
                            options = locations.map(loc => ({ value: loc.id, label: loc.name }));
                        }
                        break;
                    case 'tags':
                        if (tags && tags.length > 0) {
                            options = tags.map(tag => ({ value: tag.id, label: tag.name }));
                        }
                        break;
                    case 'resources':
                        if (resources && resources.length > 0) {
                            options = resources.map(res => ({ value: res.id, label: res.name }));
                        }
                        break;
                }
            }

            return {
                ...filter,
                options: options.length > 0 ? options : filter.options || []
            };
        });
    }, [filterOptions, categories, locations, tags, resources, t]);
};

export default useProcessedFilterOptions;
